import i18n from 'i18next';
import Yup from '../../services/common/validation';

export const documentUploadItemValidationSchema = () => {
  return Yup.object({
    documentType: Yup.string().required(i18n.t('validation:required')),
    otherDocumentTypeDescription: Yup.string().required(i18n.t('validation:required')),
  });
};
